// @ts-nocheck
import React from 'react';
import styled from 'styled-components';

interface ITabPanelProps {
  tabValue: string;
  activeTab: string;
  children: React.ReactNode;
  isSmallMode?: boolean;
}

interface IRootProps {
  id: string;
  children?: React.ReactNode;
  isSmallMode?: boolean;
}

const TabPanel: React.FC<ITabPanelProps> = (props) => {
  const { tabValue, children, isSmallMode = false } = props;
  return <Root isSmallMode={isSmallMode} id={tabValue}>{children}</Root>;
};

export default TabPanel;

const Root = styled.div<IRootProps>`
  padding: ${(props) => (props.isSmallMode ? '2px' : '10px')};
`;
